export default __webpack_public_path__ + "static/media/clothes.b949eba3.png";